export enum ActionResultStatus {
    None = 'None',
    Success = 'Success',
    Executing = 'Executing',
    Error = 'Error',
}
